import { Input } from '@yes.technology/react-toolkit'

const cssClassToStatusClass = {
  'is-valid': 'valid',
  'is-invalid': 'error',
  '': 'default'
}

function ActivityInputArea({
  id,
  cssClass,
  informational,
  required,
  value,
  onChange,
  label,
  helpText,
  explanationText,
  disabled
}) {
  const handleValue = (value) => {
    onChange(value)
  }

  return (
    <Input
      component='textarea'
      id={id}
      label={label}
      placeholder={helpText || explanationText}
      value={value}
      onChange={handleValue}
      required={required}
      informational={informational}
      statusClass={cssClassToStatusClass[cssClass]}
      heightClass='regular'
      disabled={disabled}
    />
  )
}

export default ActivityInputArea
